module.exports = __webpack_public_path__ + "static/media/construction.0b3dd473.jpg";